import {
    Box,
    Chip,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import stringUtils from "../../utils/stringUtils";
import { Link } from "react-router-dom";

const TableDadosInternosListagem = (props) => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [pagina, setPagina] = useState(0);

    useEffect(() => {
        setRows(props.rows);
        setTotal(props.total);
        setPagina(props.pagina);
    }, [props.rows, props.total, props.pagina]);

    const padding = props.padding ? props.padding : 12;

    const emptyRows = 10 - Math.min(10, rows.length);

    return (
        <Paper>
            <TableContainer>
                <Table aria-label="sticky table" sx={{ minHeight: "38rem" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Empresa</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Documento</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Ultima Atualização</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Visualização</b>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                <TableCell align="center" style={{ padding: padding }}>
                                    <Box fontSize={13}>
                                        {row.empresa_nome}
                                    </Box>
                                </TableCell>
                                <TableCell align="center" style={{ padding: padding }}>
                                    <Box fontSize={13}>
                                        {stringUtils.formatDocumento(row.documento)}
                                    </Box>
                                </TableCell>
                                <TableCell align="center" style={{ padding: padding }}>
                                    <Box fontSize={13}>
                                        {stringUtils.formatDateComplete(row.data_relatorio)}
                                    </Box>
                                </TableCell>
                                <TableCell align="center" style={{ padding: padding }}>
                                    {row.status == 2 && (
                                        <Tooltip title="Visualizar">
                                            <IconButton
                                                component={Link}
                                                to={`/relatorios/${row.id}`}
                                                aria-label="visualizar"
                                                size="small"
                                                height={11}
                                                width={11}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={8} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={parseInt(total)}
                rowsPerPage={10}
                page={parseInt(pagina)}
                onChangePage={props.handleChangePage}
            />
        </Paper>
    );
};

export default TableDadosInternosListagem;
